"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var MainDashboard = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MainDashboard, _Component);

  function MainDashboard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MainDashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MainDashboard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(MainDashboard, [{
    key: "render",
    value: function render() {
      var child = null;

      if (this.content) {
        child = _react.default.createElement(require(this.content.child_type).default, this.content);
      }

      return child;
    }
  }]);
  return MainDashboard;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = MainDashboard;